<template>
  <div
    class="image-input placeholder-img-size"
  >
    <img
      v-if="imageMode === 'view' && src !== ''"
      :src="src"
    />
  <!-- CropperJS -->
      <vue-cropper
        v-if="imageMode === 'crop'"
        ref="cropper"
        :src="imageSrc"
        alt="Source Image"
        :aspect-ratio="aspectRatioWidth / aspectRatioHeight"
        :zoomable="false"
        @ready="getCroppedSrc()"
        @cropmove="getCroppedSrc()"
        @cropend="getCroppedSrc()"
      >
      </vue-cropper>
      <!-- CropperJS -->
  </div>
</template>

<script>
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

export default {
  name: 'ImageInput',
  props: ['aspectRatioWidth', 'aspectRatioHeight', 'imageMode', 'src'],
  components: { VueCropper },
  methods: {
    getCroppedSrc() {
      if (this.$refs.cropper) {
        const croppedImageInformation = {};
        const cropperJSData = this.$refs.cropper.getData();

        croppedImageInformation.xOffset = cropperJSData.x;
        croppedImageInformation.yOffset = cropperJSData.y;
        croppedImageInformation.width = cropperJSData.width;
        croppedImageInformation.height = cropperJSData.height;

        this.$store.dispatch('setCroppedBoundaries', croppedImageInformation);
      }
    },
  },
  computed: {
    imageSrc() {
      return this.$store.state.cropImageInformation.imageSrc;
    },
  },
  watch: {
    imageSrc(newImageSrc, oldImageSrc) {
      if (newImageSrc !== oldImageSrc) {
        this.getCroppedSrc();
      }
    },
  },
  created() {
    this.getCroppedSrc();
  },
};
</script>

<style lang="scss">
.image-input {
  position: relative;
  display: inline-block;
  min-height: 400px;
  min-width: 400px;
  cursor: pointer;
  border: 5px solid #dddddd;

  img {
    pointer-events: none;
    max-width: 100%;
  }

  .image-click-icon {
    position: absolute;
    pointer-events: none;
    bottom: 0;
    right: 0;
    height: 30px;
    width: 30px;
    padding: 4px 0 0 4px;
    background: #dddddd;
  }

  .image-preview-overlay {
    display: none;
    position: absolute;
    pointer-events: none;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(100, 100, 100, 0.8);
    padding: 20px;
    text-align: center;

    h1 {
      width: 100%;
      font-size: 24px !important;
      line-height: 60px;
    }

    .image-clear {
      pointer-events: all;
    }
  }

  &.empty {
    min-width: 500px;
    min-height: 500px;

    .image-click-icon {
      display: none;
    }
  }

  &.hover,
  &.empty {
    border: 5px dashed #dddddd;

    .image-preview-overlay {
      display: flex;
    }
  }
}
</style>
